<div *ngIf="orderState < 0">

  <div class="columns" style="margin-top: -50px;">
    <div class="column is-2"></div>
    <div class="column has-text-left">
      <div class="content" style="margin-left:0;margin-right:0;">
        <p>
          <span class="title is-4">Ups, da ist was schiefgegangen!</span><br><br>
          Bitte laden Sie die Seite neu<br>
          Bei weiteren Problemen hilft ihn gerne der Support weiter<br>
          <br>
        </p>


        <div>
          <div class="success-button-box">
            <div class="is-6">
              <a onclick="location.reload();" class="success-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="34.875" height="34.875" viewBox="0 0 34.875 34.875">
                  <path id="Icon_awesome-arrow-alt-circle-right" data-name="Icon awesome-arrow-alt-circle-right" d="M18,.563A17.438,17.438,0,1,1,.563,18,17.434,17.434,0,0,1,18,.563ZM9.844,21.094H18v4.985a.844.844,0,0,0,1.441.6L27.478,18.6a.836.836,0,0,0,0-1.188L19.441,9.323a.844.844,0,0,0-1.441.6v4.985H9.844A.846.846,0,0,0,9,15.75v4.5A.846.846,0,0,0,9.844,21.094Z" transform="translate(35.438 35.438) rotate(-180)" fill="#fff"/>
                </svg>
                <span>Neu laden</span>
              </a>
            </div>
          </div>
        </div>


      </div>
    </div>
    <div class="column is-4 has-text-left">

      <div class="content" style="margin-left:0;margin-right:0;">
        <p class="support-text">
          <span class="is-bold">SUPPORT</span><br>
          <br>
          DocEstate GmbH<br>
          Digitales Gründerzentrum<br>
          Werkstraße 2<br>
          63739 Aschaffenburg <br>
          <br>
          Tel.: + 49 6021 391 1560/ 1561 <br>
          Fax.: + 49 6021 901 5682<br>
          Mail: anfragen@docestate.com<br>

        </p>
        <hr class="support-line">

        <img class="custom-img" src="assets/images/logo/logo_black.svg" alt="DocEstate Logo">
      </div>
    </div>

  </div>
</div>
<div *ngIf="orderState > 0">

  <div class="columns">
    <div class="column is-2"></div>
    <div class="column has-text-left">
      <div class="content" style="margin-left:0px;margin-right:0px;">

        <h1 class="title is-4 is-uppercase">Herzlichen Dank für Ihren Auftrag!</h1>
        <figure>
          <svg xmlns="http://www.w3.org/2000/svg" width="238.615" height="137.017" viewBox="0 0 238.615 137.017">
            <path id="Icon_ionic-md-done-all" data-name="Icon ionic-md-done-all"
                  d="M180.63,21.977,166.264,7.664,101.091,72.593,115.46,86.909ZM224.248,7.664,115.46,115.539,72.868,73.105,58.5,87.42l56.959,57.261,123.155-122.7ZM0,87.42l57.473,57.261,14.368-14.314L14.883,73.105Z"
                  transform="translate(0 -7.664)" fill="#336e99"/>
          </svg>
        </figure>

        <p>Ihre Bestellung war erfolgreich! - ID {{orderId}}<br>
          Wir haben Ihnen eine Bestellbestätigung per E-Mail geschickt.<br>
          <br>
          Sobald neue Dokumente eintreffen, kontaktieren wir Sie per E-Mail.<br>
          Den Status Ihrer Bestellungen können Sie auch jederzeit im <a href="/home">Persönlichen Bereich</a>
          einsehen<br>
          <br>
      </div>
    </div>
    <div class="column is-4 has-text-left">

      <div class="content" style="margin-left:0px;margin-right:0px;">
        <p>
          <span class="is-bold">Fragen?</span><br>
          <br>
          DocEstate GmbH<br>
          Vilbeler Straße 29<br>
          60313 Frankfurt am Main <br>
          <br>
          Tel.: + 49 69 428928950<br>
          Mail: anfragen@docestate.com<br>
        </p>
        <hr>

        <img class="custom-img" src="assets/images/logo/logo_black.svg" alt="DocEstate Logo">
      </div>
    </div>

  </div>
</div>
